// extracted by mini-css-extract-plugin
export default {"auth_card":"ULg5jR","auth_card__title":"tr5TQU"};